import { StripeConnectionKind } from "@common/types/stripeConnection";

interface IncompleteStripeConnectionInput {
    kind?: string | null;
    chargesEnabled?: boolean | null;
    error?: string | null;
    isAbandoned?: boolean | null;
}

/**
 * A Stripe connection is "Incomplete" when it is a Kick-created Express account
 * whose KYC is not yet finished, so it cannot collect payments. Incomplete is
 * NOT an error: it only holds when `error` is absent. Never derive Incomplete
 * from `chargesEnabled` alone — an OAuth connection with charges disabled is not
 * Incomplete.
 */
export function isIncompleteStripeConnection(
    connection: IncompleteStripeConnectionInput,
): boolean {
    return (
        connection.kind === StripeConnectionKind.EXPRESS &&
        connection.chargesEnabled === false &&
        connection.error == null &&
        connection.isAbandoned !== true
    );
}

/**
 * An Express connection whose KYC is complete: it collects payments and shows as
 * Connected (with a "Payments" badge in the integrations pane).
 */
export function isReadyStripeExpressConnection(
    connection: IncompleteStripeConnectionInput,
): boolean {
    return (
        connection.kind === StripeConnectionKind.EXPRESS &&
        connection.chargesEnabled === true
    );
}

export function isStripeExpressConnection(
    connection: object | null | undefined,
): boolean {
    if (connection == null || !("kind" in connection)) {
        return false;
    }
    return connection.kind === StripeConnectionKind.EXPRESS;
}
